export default __webpack_public_path__ + "static/media/tag.47d3a7a9.svg";